import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const RouterContext = createContext(null);
const readLocation = () => ({ pathname: window.location.pathname, search: window.location.search, hash: window.location.hash });

export function Router({ children }) {
  const [location, setLocation] = useState(readLocation);
  const navigate = useCallback((to, { replace = false } = {}) => {
    const url = new URL(to, window.location.origin);
    window.history[replace ? 'replaceState' : 'pushState']({}, '', `${url.pathname}${url.search}${url.hash}`);
    setLocation(readLocation());
  }, []);

  useEffect(() => {
    const update = () => setLocation(readLocation());
    window.addEventListener('popstate', update);
    return () => window.removeEventListener('popstate', update);
  }, []);

  const value = useMemo(() => ({ location, navigate }), [location, navigate]);
  return <RouterContext.Provider value={value}>{children}</RouterContext.Provider>;
}

export function useLocation() { return useContext(RouterContext).location; }
export function useNavigate() { return useContext(RouterContext).navigate; }

export function Link({ to, children, onClick, target, ...props }) {
  const navigate = useNavigate();
  function follow(event) {
    onClick?.(event);
    if (event.defaultPrevented || target === '_blank' || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(to, window.location.origin);
    if (url.origin !== window.location.origin) return;
    event.preventDefault();
    navigate(`${url.pathname}${url.search}${url.hash}`);
  }
  return <a href={to} target={target} onClick={follow} {...props}>{children}</a>;
}
